import axios from 'axios';
import date from 'date-and-time';

export const api_get = async (url, token = localStorage.getItem('authToken')) => {
  if (!process.env.REACT_APP_API_DOMAIN) {
    throw new Error('REACT_APP_API_DOMAIN environment variable is not defined');
  }

  url = `${process.env.REACT_APP_API_DOMAIN}/${url}`;

  try {
    const headers = {
      'Content-Type': 'application/json',
      ...(token && { token }),  
    };

    const response = await axios.get(url, { headers });
    return response.data;
  } catch (error) {
    console.error('GET request error:', error);
    throw error;  
  }
};

export const api_post = async (url, data, token = localStorage.getItem('authToken')) => {
  if (!process.env.REACT_APP_API_DOMAIN) {
    throw new Error('REACT_APP_API_DOMAIN environment variable is not defined');
  }

  url = `${process.env.REACT_APP_API_DOMAIN}/${url}`;

  try {
    const headers = {
      'Content-Type': 'application/json',
      ...(token && { token }),  
    };
    
    const response = await axios.post(url, data, { headers });

    return response.data;
  } catch (error) {
    console.error('POST request error:', error);
    throw error;  
  }
};

export const any_date_time_add_type = (count, type, format = 'YYYY-MM-DD HH:mm:ss') => {
  const dateObj = new Date();  
  let newDate;

  const validTypes = new Set(['second', 'minute', 'hour', 'day', 'month', 'year']);

  if (!validTypes.has(type)) {
    throw new Error('Invalid type provided. Use "second", "minute", "hour", "day", "month", or "year".');
  }

  switch (type) {
    case 'second':
      newDate = date.addSeconds(dateObj, count);
      break;
    case 'minute':
      newDate = date.addMinutes(dateObj, count);
      break;
    case 'hour':
      newDate = date.addHours(dateObj, count);
      break;
    case 'day':
      newDate = date.addDays(dateObj, count);
      break;
    case 'month':
      newDate = date.addMonths(dateObj, count);
      break;
    case 'year':
      newDate = date.addYears(dateObj, count);
      break;
  }

  return date.format(newDate, format);
};